import React from 'react';

import AvailabilityStore from '../stores/AvailabilityStore.js';
import AvailabilityActions from '../actions/AvailabilityActions.js';

import { translate } from 'react-i18next';

var BusinessSeats = React.createClass({

	getInitialState() {
		return {store: AvailabilityStore.getState()};
	},

	componentDidMount() {
        AvailabilityStore.listen(this.onChange);
        window.scrollTo(0, 0);
	},

	componentWillUnmount() {
		AvailabilityStore.unlisten(this.onChange);
	},

	onChange(state) {
		this.setState({store: state});
	},

	updateBusinessSeatsSmallBusiness() {
		var service_type = 'small_business';

	    this.state.store = this.state.store.setIn(['input_address', 'serviceType'], service_type);
	    this.state.store = this.state.store.set('serviceType', service_type);
	    this.state.store = this.state.store.set('service_type_manually_selected', true);

		AvailabilityActions.updateServiceType('small_business');
		AvailabilityActions.hideBusinessType();
		AvailabilityActions.reQualSmallBusiness();

		AvailabilityActions.prequal(this.state.store.toJS());
	},

	notMyAddr() {
	    AvailabilityActions.businessNotMyAddr();
	},

    browseServiceOfferings(url) {
        AvailabilityActions.browseServiceOfferings();
        window.location.assign(url);
    },

    handleSelect(name, value) {
        // setState is Async so you cant test the value right after you set it, but it will change immediately in render()
        this.setState({[name]: value});
        this.setState({'submit_tried': undefined});
    },

    handleSubmit(query_string, is_business_park_fiber) {

        if ((this.state.employees !== undefined && this.state.phone_lines !== undefined && this.state.budget !== undefined) || is_business_park_fiber) {

            if (!is_business_park_fiber && (
                    (  this.state.budget.indexOf('Under') != -1 && this.state.phone_lines == '0')
                    || (this.state.budget.indexOf('Under') != -1  && this.state.employees == '1-4')
                    || (this.state.budget.indexOf('Under') != -1  && this.state.phone_lines == '1-2' && this.state.employees == '5-10'))
                ) {
                this.updateBusinessSeatsSmallBusiness();
            } else {

                var business_needs = [];
                business_needs.push(query_string);
                business_needs.push('employees='+this.state.employees);
                business_needs.push('phone_lines='+this.state.phone_lines);
                business_needs.push('budget='+this.state.budget);
                var url_params = business_needs.join("&");

                var base = window.develorigin ? window.develorigin : window.location.origin;

                this.browseServiceOfferings(base+ "/business-offerings?"+url_params);
            }

        } else {
            //highlight on non filled selection
            this.setState({'submit_tried': 1});
        }

    },


    isBusinessParkFiber() {
        let products = this.state.store.get('products').toJS();
	    let is_bpf = products.filter(function(product) {
	            return typeof product.is_fttb != 'undefined' && product.is_fttb;
	    }).length;
        return is_bpf;
    },

    isFiberAvailable() {
        let products = this.state.store.get('products').toJS();
        let is_fiber_available = products.filter(function(product) {
            return product.technology == 'fttx' && product.product_key.indexOf('fiber_dia') == -1;
	    }).length;
        return is_fiber_available;
    },

    isOpenPreorder() {
        return this.state.store.getIn(['lastPrequal', 'response', 'is_open_preorder_address']);
    },

    getQueryString() {
        let qual_addr = this.state.store.get('qualified_address').toJS();
        let is_bpf = this.isBusinessParkFiber();
        let is_fiber_available = this.isFiberAvailable();
        let is_open_preorder = this.isOpenPreorder();

        let query_string = [];

	    query_string.push('prequal_tracking_key='+this.state.store.get('prequal_tracking_key'));

        if (!is_open_preorder){
	        if(is_bpf) {
	            query_string.push('is_bpf=1');
	        } else if(is_fiber_available) {
	            query_string.push('is_fttx=1');
	        }

	        if(this.state.store.getIn(['lastPrequal', 'response', 'is_preorder_address'])) {
                query_string.push('pre=1');
	        }
        }

	    for(var i in qual_addr) {
	      if(qual_addr.hasOwnProperty(i)) {
	        query_string.push(encodeURIComponent(i) + "=" + encodeURIComponent(qual_addr[i]));
	      }
	    }
	    return query_string.join("&");
    },

	render() {
		const { t } = this.props;
        var store = this.state.store;

        //var business_store = store.get('business_store').toJS();

        var employees = this.state.employees;
        var phone_lines = this.state.phone_lines;
        var budget = this.state.budget;

        var submit_tried = this.state.submit_tried;
        var disabled = (employees !== undefined && phone_lines !== undefined && budget !== undefined) ? 0 : 1;

        var qual_addr = store.get('qualified_address').toJS();
        var postal = store.get('postal_address').toJS();

        var is_bpf = this.isBusinessParkFiber();
        var querystr = this.getQueryString();

        var budget_amt = this.isFiberAvailable() ? '$250' : '$400';
        var qual_issue = '';

        if(store.get('sso_user')) {
            var qual_issue = <div style={{width:'150px',margin:'auto'}}><a className="snc-btn snc-btn--sm" href={'https://sontec.sontrak.net/sontec-ng/ticket/create/qual/?prequal_key=' + this.state.store.get('prequal_tracking_key')} target="_blank">Qual Issue</a></div>
        }

		return (
            <div className="snc-section--qualifying-questions">
                <div className="container">
                    <div className="qq-intro">
                    <h1>{t('common:business_seats.title')}</h1>
                    <div className="address capitalize">({qual_addr.address.toLowerCase()}, {postal.city ? postal.city.toLowerCase() : ''} {qual_addr.state} {qual_addr.zip})</div>
                    <div className="change">
                        <a onClick={this.notMyAddr}>{t('common:business_seats.change_address')}</a>
                    </div>
                    {qual_issue}
                    </div>
                    <div className="qq-items">
                    <div className="qq-item">
                        <div className="qq-question">{t('common:business_seats.employees')}</div>
                        <div className="qq-answer">
                        <div className={'btn-group ' + ((employees === undefined && submit_tried === 1) ? 'highlight' : '')} data-toggle="buttons">
                            <label className={'btn btn-default ' + (employees === "1-4" ? 'active' : '')} onClick={() => this.handleSelect('employees','1-4')}>
                                <input
                                    type="radio"
                                    name="employees"
                                    value="1-4"
                                />
                                <span>1 to 4</span>
                            </label>
                            <label className={'btn btn-default ' + (employees === "5-10" ? 'active' : '')} onClick={() => this.handleSelect('employees','5-10')}>
                                <input
                                    type="radio"
                                    name="employees"
                                    value="5-10"

                                />
                                <span>5 to 10</span>
                            </label>
                            <label className={'btn btn-default ' + (employees === "11 or more" ? 'active' : '')} onClick={() => this.handleSelect('employees','11 or more')}>
                                <input
                                    type="radio"
                                    name="employees"
                                    value="11 or more"
                                />
                                <span>11 or more</span>
                            </label>
                        </div>
                        </div>
                    </div>
                    <div className="qq-item">
                        <div className="qq-question">{t('common:business_seats.phone_lines')}</div>
                        <div className="qq-answer">
                        <div className={'btn-group ' + ((phone_lines === undefined && submit_tried === 1) ? 'highlight' : '')} data-toggle="buttons">
                            <label className={'btn btn-default ' + (phone_lines === "0" ? 'active' : '')} onClick={() => this.handleSelect('phone_lines','0')}>
                                <input
                                    type="radio"
                                    name="phone_lines"
                                    value="0"
                                />
                                <span>0</span>
                            </label>
                            <label className={'btn btn-default ' + (phone_lines === "1-2" ? 'active' : '')} onClick={() => this.handleSelect('phone_lines','1-2')}>
                                <input
                                    type="radio"
                                    name="phone_lines"
                                    value="1-2"

                                />
                                <span>1 or 2</span>
                            </label>
                            <label className={'btn btn-default ' + (phone_lines === "3 or more" ? 'active' : '')} onClick={() => this.handleSelect('phone_lines','3 or more')}>
                                <input
                                    type="radio"
                                    name="phone_lines"
                                    value="3 or more"

                                />
                                <span>3 or more</span>
                            </label>
                        </div>
                        </div>
                    </div>
                    <div className="qq-item">
                        <div className="qq-question">{t('common:business_seats.budget') + ' ' +budget_amt + '/month?'}</div>
                        <div className="qq-answer">
                        <div className={'btn-group ' + ((budget === undefined && submit_tried === 1) ? 'highlight' : '')} data-toggle="buttons">
                            <label className={'btn btn-default ' + (budget === "Under " + budget_amt ? 'active' : '')} onClick={() => this.handleSelect('budget','Under ' + budget_amt)}>
                                <input
                                    type="radio"
                                    name="budget"
                                    value={'Under' + budget_amt}

                                />
                                <span>Under</span>
                            </label>
                            <label className={'btn btn-default ' + (budget === "Over " + budget_amt ? 'active' : '')} onClick={() => this.handleSelect('budget','Over ' + budget_amt)}>
                                <input
                                    type="radio"
                                    name="budget"
                                    value={'Over' + budget_amt}

                                />
                                <span>Over</span>
                            </label>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div className="qq-continue">
                    <p>{t('common:business_seats.click_button')}</p>
                    <div>
                        <a className={'snc-btn ' + (disabled === 1 ? 'disabled' : '')} disabled={disabled} onClick={() => this.handleSubmit(querystr, is_bpf)}>Continue</a>
                    </div>
                    </div>
                </div>
			</div>
		);
	}
});

export default  translate('common', { wait: true })(BusinessSeats);
